/**
 * Formularprüfung mit sichtbarer Rückmeldung.
 *
 * Hintergrund: `$refs.Form.validate()` markiert das fehlerhafte Feld zwar rot,
 * springt aber nicht dorthin. Bei langen Formularen steht der Absende-Button weit
 * unter dem Fehler — man klickt, es passiert scheinbar nichts, und der Eindruck
 * entsteht, das Formular sei abgeschickt worden.
 *
 * `validateForm` prüft wie gehabt und holt im Fehlerfall das erste beanstandete
 * Feld ins Bild.
 */

/** Springt zum ersten Feld mit Fehler und setzt den Cursor hinein. */
function focusFirstError(form) {
    const inputs = form.inputs || []
    const fehlerhaft = inputs.find((input) => input.hasError || (input.errorBucket || []).length > 0)
    if (!fehlerhaft || !fehlerhaft.$el) return

    try {
        if (typeof fehlerhaft.focus === "function") fehlerhaft.focus()
        // Nach dem Fokus zentrieren, sonst klebt das Feld am oberen Rand
        // und die Meldung darunter bleibt unsichtbar.
        fehlerhaft.$el.scrollIntoView({ block: "center" })
    } catch (error) {
        console.error("Konnte nicht zum fehlerhaften Feld springen:", error)
    }
}

/**
 * Prüft das Formular. Gibt true zurück, wenn abgeschickt werden darf.
 * Im Fehlerfall wird zum ersten beanstandeten Feld gesprungen.
 *
 * Fehlt die Referenz (falscher ref-Name, Formular noch nicht gerendert), wird
 * NICHT freigegeben: sonst ginge ein ungeprüftes Formular still hinaus, und
 * genau das ist der teure Fall — Adresse ohne @, leere Pflichtfelder, fehlender
 * Datenschutz-Haken. Lieber laut in der Konsole als stumm abgeschickt.
 */
export default function validateForm(form) {
    if (!form || typeof form.validate !== "function") {
        console.error("validateForm: kein v-form übergeben — Absenden wird verweigert.", form)
        return false
    }

    const gueltig = form.validate()
    if (!gueltig) focusFirstError(form)
    return gueltig
}
